import { Checkbox, Divider } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';
import styles from './AlertItem.module.scss';
import { AlertOption } from './AlertPopup.logic';

const cx = classNames.bind(styles);

interface AlertItemProps {
  title: string;
  description: string;
  options: AlertOption[];
  selectedOption: string;
  onOptionSelect: (alert: string) => void;
  alertsEnabled: boolean;
  toggleAlerts: (values: boolean) => void;
  dataTestPrefix: string;
  isDisabled: boolean;
}

const AlertItem = (props: AlertItemProps): ReactElement => {
  const {
    title,
    description,
    options,
    selectedOption,
    alertsEnabled,
    onOptionSelect,
    toggleAlerts,
    dataTestPrefix,
    isDisabled,
  } = props;

  const onOptionChange = (_, data) => {
    onOptionSelect(data.value);
  };

  return (
    <div className={cx('body')}>
      <div className={cx('content')}>
        <div className={cx('header')}>
          <div className={cx('title')}>{title}</div>
          <Checkbox
            checked={alertsEnabled}
            dataTestId={`${dataTestPrefix}-alerts-toggle`}
            onClick={() => toggleAlerts(!alertsEnabled)}
            toggle
            disabled={isDisabled}
          />
        </div>
        <div className={cx('description')}>{description}</div>
      </div>
      {alertsEnabled && (
        <div className={cx('content')}>
          <div className={cx('period')}>Email frequency</div>
          <div className={cx('actions')}>
            {options.map((option) => (
              <Checkbox
                radio
                label={option.label}
                name="alertsGroup"
                value={option.value}
                checked={selectedOption === option.value}
                onChange={onOptionChange}
                dataTestId={`${dataTestPrefix}-alert-${option.label}-radio-button`}
                aria-label={option.label}
                disabled={isDisabled}
                key={option.value}
              />
            ))}
          </div>
        </div>
      )}
      <Divider className={cx('divider')} />
    </div>
  );
};

export default AlertItem;
